const ACTIONS = {
    NOTIFICATION_COUNT: "notification-count",
  };
  
  export default ACTIONS;
  